<template>
  <div v-wechat-title="titleTop">
    <div class="rectBack">
      <div class="topTitle"><div class="iconLeft"/>新增投诉</div>
      <div class="lineRect">
        <div class="title">投诉内容<span class="requiredStr">*</span></div>
        <van-button type="primary" color="#3D76BC" @click="onChange1('潜水课程')" :plain="formData.comType1!=='潜水课程'" round style="padding: 0 5px;margin-right:0.5em;line-height: 2.5em;height: 2.5em;">潜水课程</van-button>
        <van-button type="primary" color="#3D76BC" @click="onChange1('持证潜水')" :plain="formData.comType1!=='持证潜水'" round style="padding: 0 5px;margin-right:0.5em;line-height: 2.5em;height: 2.5em;">持证潜水</van-button>
        <van-button type="primary" color="#3D76BC" @click="onChange1('船宿行程')" :plain="formData.comType1!=='船宿行程'" round style="padding: 0 5px;line-height: 2.5em;height: 2.5em;">船宿行程</van-button>
      </div>
      <div class="lineRect">
        <div class="title">投诉标题<span class="requiredStr">*</span></div>
        <van-field v-model="formData.title" placeholder="对XX教练XXX问题的投诉" maxlength="120" style="width:calc(100vw - 10em);line-height: 2.5em;height: 2.5em;padding:0;" />
      </div>
      <div class="lineRect">
        <div class="title">投诉主体<span class="requiredStr">*</span></div>
        <van-field readonly v-model="formData.zhuti" @click="onShowComType1" style="width:calc(100vw - 12em);line-height: 2.5em;height: 2.5em;padding:0;" />
        <div class="rightjt"><i class="iconfont icondownjt"/></div>
      </div>
      <div class="lineRect">
        <div class="title">投诉类别<span class="requiredStr">*</span></div>
        <van-field readonly v-model="formData.comType2" @click="onShowComType2" style="width:calc(100vw - 12em);line-height: 2.5em;height: 2.5em;padding:0;" />
        <div class="rightjt"><i class="iconfont icondownjt"/></div>
      </div>

      <div class="baseRect">
        <div class="title">投诉相关证明材料<span class="requiredStr">*</span></div>
        <van-uploader
          v-model="fileList"
          multiple
          :max-count="10"
          :after-read="afterRead"
        />
         <div class="aboutImg">最多上传10张图片，每张图片大小不超过5M您需提供有关举证材料(包括但不限于)支持您投诉内容的举证照片/截图等等.</div>
      </div>


      <div class="baseRect">
        <div class="title">举报详情描述<span class="requiredStr">*</span></div>
        <van-field v-model="formData.body" type="textarea" placeholder="请对投诉内容充分，清晰的投诉理由说明" rows="3" maxlength="3000" show-word-limit style="box-shadow: 0px 0px 6px #aaa;"/>
      </div>

      <div class="baseRect">
        <div class="title">投诉请求<span class="requiredStr">*</span></div>
        <van-field v-model="formData.needbody" type="textarea" placeholder="请简述您真对此次投诉所提出的具体请求事项。例如：XX教练教学过程不达教学规范，希望酷潜对其进行XX处理" 
          rows="3" maxlength="3000" show-word-limit style="box-shadow: 0px 0px 6px #aaa;"/>
      </div>

      <div class="lineRect">
        <div class="title" style="width: 6em;">投诉人<span class="requiredStr">*</span></div>
        <van-field v-model="formData.recvName" placeholder="投诉人姓名，例如”张三“" maxlength="30" style="width:calc(100vw - 11em);line-height: 2.5em;height: 2.5em;padding:0;" />
      </div>
      <div class="lineRect">
        <div class="title" style="width: 6em;">投诉订单号<span class="requiredStr">*</span></div>
        <van-field v-model="formData.orderno" placeholder="课程订单号或付款编号" maxlength="30" style="width:calc(100vw - 11em);line-height: 2.5em;height: 2.5em;padding:0;" />
      </div>
      <div class="lineRect">
        <div class="title" style="width: 11em;">允许转发权属证明材料<span class="requiredStr">*</span></div>
        <van-radio-group v-model="formData.thirdSuccess" direction="horizontal" style="line-height: 2.5em;height: 2.5em;padding:0;" >
          <van-radio name="true">是</van-radio>
          <van-radio name="false">否</van-radio>
        </van-radio-group>
        <div class="about">若后续被诉方对处理结果存在异议，允许酷潜将转发上述权属证明材料图片至被投诉方或第三方</div>
        <div style="height:2em"></div>
      </div>
      <div class="lineRect">
        <div class="title" style="width: 11em;">投诉人身份证号<span class="requiredStr">*</span></div>
        <van-field v-model="formData.recvID" maxlength="30" style="width:calc(100vw - 17em);line-height: 2.5em;height: 2.5em;padding:0;" />
      </div>
      <div class="lineRect">
        <div class="title" style="width: 11em;">投诉人联系方式(邮箱)<span class="requiredStr">*</span></div>
        <van-field v-model="formData.recvEmail" maxlength="60" style="width:calc(100vw - 17em);line-height: 2.5em;height: 2.5em;padding:0;" />
      </div>
      <div class="lineRect">
        <div class="title" style="width: 11em;">其他联系方式</div>
        <van-field v-model="formData.recvPhone" maxlength="60" style="width:calc(100vw - 17em);line-height: 2.5em;height: 2.5em;padding:0;" />
      </div>
      <div class="downCheck">
        <van-checkbox v-model="checked" shape="round">我承诺以上信息和资料的真实有效，并愿承担因此带来的潜在法律风险。</van-checkbox>
      </div>
      <van-button type="primary" loading-text="正在提交中" :loading="buttonLoading" :disabled="!checked" color="linear-gradient(to right, #11BCFA, #198FFE)" style="width:100%;" @click="onSendComplaint">提交</van-button>
    </div>
    <van-popup v-model="showComType1" round position="bottom">
      <van-picker
        title="选择投诉主体"
        show-toolbar
        :columns="comType1"
        @confirm="onConfirmType1"
        @cancel="onCancelType1"
      />
    </van-popup>
     <van-popup v-model="showComType2" round position="bottom">
      <van-picker
        title="选择投诉类别"
        show-toolbar
        :columns="comType2"
        @confirm="onConfirmType2"
        @cancel="onCancelType2"
      />
    </van-popup>
    <wxShare v-model="showShare" :title="shareTitle" :desc="shareAbout" :timeline="shareTimeline" :url="shareUrl" :img="shareIcon" @onFinish="onShareFinish" />
  </div>
</template>
<script>
import request from '@/utils/request'
import TopBar from '@/components/TopBar'
import { Uploader, Button, Popup, Field, Toast,RadioGroup, Radio,Checkbox ,Picker } from 'vant'
import { getUrlKey,compressorImageList, GetEnumList, MyNotify, GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
import FieldSelect from '@/components/FieldSelect'
import wxShare from '@/components/wxShare'
import { GetSelfUrl } from '@/utils/request'

export default {
  components: {
    [Uploader.name]: Uploader,
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Field.name]: Field,
    [Toast.name]: Toast,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Checkbox.name]: Checkbox,
    [Picker.name]: Picker,
    TopBar,
    FieldSelect,
    wxShare
  },
  props: {
    // eslint-disable-next-line
    value:undefined,
  },
  data() {
    return {
      system:'',
      titleTop: '酷潜品质管理',
      showBind: false,
      buttonLoading: false,
      typeList: [],
      fileList: [],
      checked:false,
      formDataEmpty:{},
      formData: {
        imgs:'',
        body: '',
        type: 'FULL',
        comType: '',
        comType1: '',
        comType2: '',
        needbody: '',
        orderno: '',
        person: '',
        recvID: '',
        recvEmail: '',
        recvName: '',
        recvPhone: '',
        title: '',
        zhuti: ''
      },
      showComType1:false,
      showComType2:false,
      comType1:[],
      comType2:[],
      type:[
        {text:'潜水课程', 
          type1:[
            {text:'潜店人员',type2:['潜店客服','教练/潜导','其他']},
            {text:'装备',type2:['出海船只','潜水装备','其他']},
            {text:'其他',type2:['其他']},
        ]},
        {text:'持证潜水', 
          type1:[
            {text:'潜店人员',type2:['潜店客服','教练/潜导','其他']},
            {text:'装备',type2:['出海船只','潜水装备','其他']},
            {text:'其他',type2:['其他']},
        ]},
        {text:'船宿行程', 
          type1:[
            {text:'船公司',type2:['教练/潜导','接送服务','潜水安排','餐食及服务','其他']},
            {text:'其他',type2:['其他']},
        ]}
      ],
      showShare: false,
      shareTitle: '',
      shareAbout: '',
      shareTimeline: '',
      shareUrl: '',
      shareIcon: ''
    }
  },
  watch: {
    value(newValue) {
      if (newValue) {
        this.fileList = []
        setTimeout(() => {
          this.typeList = []
          this.typeList = GetEnumList('Em_ComplaintType')
          this.formData.type = ''
        }, 1)
        setTimeout(() => {
          this.formData.type = 'PROPOSAL'
        }, 10)
        this.showBind = true
      } else {
        this.showBind = false
      }
    }
  },
  created() {
    this.system = getUrlKey('system')
    this.formDataEmpty= JSON.parse(JSON.stringify(this.formData));
    this.onChange1('潜水课程')
     setTimeout(() => {
        this.title = GetSysTitle()
        this.shareAbout = ''
        this.shareTitle = '酷潜品质管理'
        this.shareTimeline = '酷潜品质管理'
        this.shareUrl = undefined
        this.shareUrl = GetSelfUrl() + 'my/complaintnew?system=' +this.system
        this.shareIcon = GetSelfUrl() + 'img/complaintnew.jpg'
      }, 100)
  },
  methods: {
    GetEnumList,
    MyNotify,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    onShareFinish() {
      this.shareUrl = undefined
    },
    onChange1(type){
      if(this.formData.comType1 !== type)
      {
        this.comType2 = [];
        this.formData.zhuti = ''
        this.formData.comType1 = ''
        this.formData.comType2 = '';
      }
      this.formData.comType1 = type
      this.comType1 = this.type.filter(el=>el.text===type)[0].type1;
      console.log("this.comType1",this.comType1)
    },
    onShowComType1(){
      this.showComType1=true;
    },
    onShowComType2(){
      if( this.comType2.length > 0){
        this.showComType2=true;
      }else{
        Toast.success('请先选择主体')
      }
    },

    onConfirmType1(el){
      console.log("onConfirmType1",el)
      this.formData.zhuti = el.text
      this.formData.comType2 = '';
      this.comType2 = el.type2;
      this.showComType1=false;
      
    },
    onCancelType1(){
      this.formData.zhuti = '';
      this.comType2 = [];
      this.showComType1=false;
    },
    
    onConfirmType2(el){
      console.log("onConfirmType2",el)
      this.formData.comType2 = el
      this.showComType2=false;
    },
    onCancelType2(){
      this.formData.comType2 = '';
      this.showComType2=false;
    },
    onTypeChange(select) {
      this.formData.type = select.value
    },
    init() {

    },
    onClosed() {
      this.$emit('input', false)
    },
    onBack() {
      this.showBind = false
      return true
    },
    onSendComplaint() {
      this.buttonLoading = true
      this.uploadImg((imgStr) => {
        console.log('uploadImg', imgStr)
        this.formData.imgs = imgStr
        request({
          url: '/user/addUserComplaintNew',
          method: 'post',
          data: this.formData
        }).then(response => {
          this.buttonLoading = false
          if (!response.success) {
            return
          }
          Toast.success('提交成功')
          this.formData= JSON.parse(JSON.stringify(this.formDataEmpty));
          this.checked=false;
          this.fileList=[];
          this.onChange1('潜水课程')
          this.$router.push('/my/complaintNewFinish')
        })
      })
    },
    uploadImg(callback) {
      var noFile = true
      var fileList = []
      this.fileList.map((value, index, array) => {
        if (value.file) {
          fileList.push(value.file)
          noFile = false
        }
      })
      if (noFile) {
        if (callback) {
          var list = []
          this.fileList.map(value => {
            list.push(value.url)
          })
          callback(list.toString())
        }
        return
      }
      compressorImageList(fileList, 1024, 1024, 0.6, (list) => {
        const formData = new FormData()
        list.map((value, index, array) => {
          if (value.name) {
            formData.append('file', value.file, value.name)
          } else {
            formData.append('file', value.file)
          }
        })
        request({
          url: '/Data/uploadFile?config=complaint',
          method: 'post',
          data: formData
        }).then(response => {
          console.log('上传图片反馈', response)
          if (!response.success) {
            this.buttonLoading = false
            return
          }
          var list = []
          this.fileList.map(value => {
            if (!value.file) {
              list.push(value.url)
            }
          })
          response.data.map((value, index, array) => {
            list.push(value.save)
          })
          if (callback) {
            callback(list.toString())
          }
        })
      })
    },
    afterRead(file) {
      console.log('file', file)
    }
  }
}
</script>
<style>
.topbar{
  background-color: #fff !important;
  color: #000 !important;
}
</style>
<style scoped>
.requiredStr{
  color: #f00;
}
.rectBack{
  background-color: #fff;
  padding: 1em;
  overflow: hidden;
  min-height: 100vh;
}
.rectBack .topTitle{
  color:#3D76BC;
  line-height: 1.4em;
}
.rectBack .iconLeft{
  width: 5px;
  border-radius: 5px;
  height: 0.8em;
  margin-top: 0.3em;
  margin-right: 0.3em;
  background-color: #3D76BC;
  float: left;
}
.baseRect{
  margin-top: 0.75em;
  position: relative;
}
.baseRect .title{
  padding-bottom: 0.5em;
  font-size: 0.9em;
  font-weight: 700;
}
.lineRect{
  border:1px solid #EBEBEB;
  border-radius: 0.3em;
  padding:0.5em;
  margin-top: 0.75em;
  position: relative;
}
.lineRect .title{
  float: left;
  line-height: 2.5em;
  width: 5em;
}
.lineRect .rightjt{
  right: 0.5em;
  top: 1em;
  color:#3D76BC;
  line-height: 1.4em;
  position: absolute;
}
.lineRect .rightjt i{
  font-size: 0.7em;
}
.about{
  float: left;
  font-size: 0.7em;
  padding-top: 0.5em;
  color: #999;
}
.aboutImg{
  font-size: 0.7em;
  padding-top: 0.5em;
  color: #999;
}
.rectBack .uploadRect{
  padding: 0.5em;
}
.backRect{
    width: 100vw;
    height: 100vh;
    background-color: #F1f1f1;
}
.inputRect{
  margin: 1em 1em 0 1em;
  background-color: #fff;
  border-radius: 0.5em;
  overflow: hidden;
}
.regAbout{
  margin:1em 2em;
  color: #999;
  font-size: 0.8em;
}
.downCheck{
  text-align: center;
  padding: 1em 0;
  font-size: 0.65em;
  color: #999;
}
</style>
